import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { phoneFormatter } from "_helpers";

import breakpoints from "_constants/breakpoints";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  @media (max-width: ${breakpoints.mobileL}) {
    padding: 24px 16px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #ecedf1;

  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
`;
const DataRow = styled.div`
  display: flex;
  min-width: 100%;
  padding: 16px 0;

  &:nth-child(2n + 1) {
    background-color: #fafaff;
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;
const Label = styled.div`
  min-width: 50%;
  width: 50%;
  padding-right: 20px;
  font-weight: normal;
  font-size: 12px;
  /* text-transform: uppercase; */
  color: #7b848d;
  word-break: break-all;

  @media (max-width: ${breakpoints.tablet}) {
    min-width: 100%;
    width: 100%;
    padding-right: 0;
  }
`;
const Data = styled(Label)`
  font-weight: bold;
  text-transform: none;
  word-break: break-all;

  @media (max-width: ${breakpoints.mobileL}) {
    align-items: center;
  }
`;
const CenterdText = styled.div`
  width: 100%;
  padding: 24px;
  color: #7b848d;
  text-align: center;
  font-weight: bold;
`;

const TrademarkPrivateContactInfoSubscription = ({ productDetails }) => {
  return (
    <Container>
      <Row>
        <DataRow>
          <Label>Private Phone Number</Label>
          <Data>{phoneFormatter(productDetails?.phoneNumber) || "—"}</Data>
        </DataRow>
        <DataRow>
          <Label>Private Email Address</Label>
          <Data>{productDetails?.email || "—"}</Data>
        </DataRow>
      </Row>
      <Row>
        <CenterdText>
          Any important phone or email correspondence will be conveyed to you by our customer service team.
        </CenterdText>
      </Row>
    </Container>
  );
};

export default TrademarkPrivateContactInfoSubscription;

TrademarkPrivateContactInfoSubscription.propTypes = {
  productDetails: PropTypes.object,
};
